<template>

  <v-dialog
    v-model="show"
    persistent
    max-width="470">
    <v-card>
        <v-card-title>
            customer
        </v-card-title>
        <v-card-text>
             <v-form
                ref="form"
                v-model="valid"
                lazy-validation
              >
              <v-row>
                <v-col sm="12">
                <v-text-field
                  v-model="customer.email"
                    label="Acct No."
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col sm="12" v-if="!customer.email">
                    <v-btn block small  @click="generate()">GENERATE ACCT NO.</v-btn>
                </v-col>

              </v-row>
               <v-text-field
                 v-model="customer.firstname"
                  label="Fullname *"
                  :rules="textRules"
                required
                ></v-text-field>
                <v-text-field
                  v-model="customer.contact_no"
                  label="Contact No. *"
                ></v-text-field>
                
                 <v-text-field
                  v-model="customer.address"
                  label="Address"
                ></v-text-field>
                
                 <v-autocomplete
                        v-model="customer.parent"
                        :items="CUSTOMERSELECTION"
                        item-text="firstname"
                        item-value="id"
                        label="Parent Customer"
                      ></v-autocomplete>


                      <v-select
                  v-model="customer.status"
                  label="Status"
                  :items="['Active','Deactivate']"
                ></v-select>  
                <v-row>
                   
                    <v-col md="6" class="pa-2">
                      <v-checkbox
                        v-model="customer.evat"
                        label="Enable EVAT"
                        color="indigo"
                        value="enabled"
                        hide-details
                       ></v-checkbox>
                    </v-col>
                    <v-col md="6" class="pa-2">
                      <v-checkbox
                        v-model="customer.credit"
                        label="Enable Credit"
                        color="red"
                        value="enabled"
                        hide-details
                       ></v-checkbox>
                    </v-col>
                </v-row>
                
             </v-form>
        </v-card-text>
        <v-card-actions>
                <v-btn color="default" small rounded text @click="emitToParent('close')">CLOSE</v-btn>
            <v-spacer></v-spacer>
            <v-btn  small color="success"  depressed  @click="validate()">{{BTN_TEXT}}</v-btn>
        </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    show: {
        type: Boolean,
        default: false
    },
    customer: {
        type: Object,
        default: ()=>{ return {}}
    },
    customerlist: {
        type: Array,
        default: ()=>{ return []}
    },
    state: {
        type: String,
        default: "new"
    }
  },
  data: () => ({
      valid: true,
      textRules: [
        v => !!v || 'Field is required'
      ],
  }),
  computed: {
      BTN_TEXT() {
          if(this.state == 'new')
            return "ADD"
         else 
            return "SAVE"
      },
      CUSTOMERSELECTION() {
      var noParent = {id:0,firstname:'No Parent'}
      var selection = this.customerlist
      selection.unshift(noParent)
      return selection
    }
  },
  watch: {
    // show () {
    //   if (this.show == false) {
    //   }
    // }
  },
  methods: {
    validate () {
        if (this.$refs.form.validate()) {
          this.emitToParent(this.state)
        }
    },
    emitToParent (action) {
    if(this.customer.status == "delete") {this.customer.status = 'deleted'}
      this.$emit('DialogEvent', {action: action, customer:this.customer})
    },
    generate(){
      this.$http.get("gen").then(response => {
            this.customer.email  = response.data.message
          }).catch(e => {
           console.log(e.data)
         })
    }
  }
}
</script>
